import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoggerService } from './logger.service';

@Injectable()
export class BaseApiService {
  protected apiUrl = environment.apiUrl;
  private enableDebugLogs = false; // Set to true only when debugging is needed

  constructor(
    protected http: HttpClient,
    protected logger?: LoggerService
  ) {}

  protected logApiCall(method: string, url: string, response?: any) {
    if (!this.enableDebugLogs || !this.logger) return;
    
    if (response) {
      this.logger.log(`[API ${method}] ${url}`, response);
    } else {
      this.logger.log(`[API ${method}] ${url}`);
    }
  }

  /** Arrow so `catchError(this.handleError)` keeps `this` (RxJS calls the handler with no receiver). */
  protected handleError = (error: HttpErrorResponse) => {
    if (this.logger) {
      this.logger.error('API Error:', error.message);
    }
    return throwError(() => error);
  };

  protected addLogging<T>(method: string, observable: Observable<T>): Observable<T> {
    if (!this.enableDebugLogs || !this.logger) return observable;

    return observable.pipe(
      tap({
        next: (response) => this.logApiCall(method, this.apiUrl, response),
        error: (error) => this.logger?.error(`[API ERROR] ${method}`, error)
      })
    );
  }
} 